














































































import SeckillTimer from './seckill_timer.vue'
import { computed } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'

export default defineClassComponent(
  {
    components: {
      SeckillTimer,
    },
  },
  () =>
    class {
      // 商品数据
      goodsData = goodsProvider.inject()

      // 秒杀信息
      seckillInfo = computed(() => this.goodsData.value.seckillInfo)

      // 秒杀数据
      seckillData = computed(() => this.goodsData.value.seckillData)

      // 点击了解会员
      handleMemberClick = () => {
        dcb.navigateTo({
          url: 'dcb://MemberPage',
        })
      }
    },
)
